// Define dataLayer and the gtag function.

type ConsentPermission = 'denied' | 'granted';

window.dataLayer = window.dataLayer || [];
function gtag(
  ..._args: [
    'consent',
    'default' | 'update',
    {
      ad_storage?: ConsentPermission;
      analytics_storage: ConsentPermission;
      functionality_storage?: ConsentPermission;
      personalization_storage?: ConsentPermission;
      security_storage?: ConsentPermission;
      ad_user_data?: ConsentPermission;
      ad_personalization?: ConsentPermission;
    },
  ]
): void {
  window.dataLayer.push(arguments);
}

export class ConsentMode {
  defaultGrantAll(): void {
    gtag('consent', 'default', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }
  defaultDenyAll(): void {
    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
  }
  updateGrantAll(): void {
    gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }
  updateDenyAll(): void {
    gtag('consent', 'update', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
  }

  initializeWithConsent(consent: Record<string, boolean>): void {
    if (consent['ga']) {
      this.defaultGrantAll();
    } else {
      this.defaultDenyAll();
    }
  }

  updateWithConsent(consent: Record<string, boolean>): void {
    if (consent['ga']) {
      this.updateGrantAll();
    } else {
      this.updateDenyAll();
    }
  }
}

const instance = new ConsentMode();
export default instance;
export type IConsentMode = typeof instance;
